export default {
  newDesign: true,
  title: "3 etkilesimli ders + bonus ders | Kodland",
  downtimeUrl: "https://www.kodland.org/tr",
  parameters: {
    landing_id: "TrSpMathA",
    segment: 12,
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
  },
  quizRotateBySteps: {
    1: {
      question: "Çocuğunuz matematik hakkında nasıl hissediyor? 🧮",
      answers: [
        "🥳 Eğlenceli ama bazen zorlayıcı",
        "😊 Fena değil, ama ekstra destek gerekli",
        "😔 Zorlayıcı ve can sıkıcı",
        "😢 Bunaltıcı geliyor"
      ],
    },
    2: {
      question: "Çocuğunuz son matematik ödevinde nasıl bir performans gösterdi?",
      answers: [
        "🌟 85–100 (Mükemmel)",
        "😊 70–84 (İyi)",
        "😐 60–69 (Orta)",
        "😟 50–59 (Ortanın Altı)",
        "😢 0–49 (Zorlanıyor)"
      ],
    },
    3: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/reviews-tr-math.png",
      title: "Veliler Kodland'i Seviyor: Matematik Kaygısından Başarıya!",
      subtitle: "Kodland’de matematik zorluklarını başarıya dönüştürüyoruz. İşte velilerden gelen yorumlar.<br>Aynı sonuçları görmek ister misiniz?",
      button: "Hazırım 🚀",
    },
    4: {
      question: "Çocuğunuzun matematikteki en büyük hedefi nedir?",
      answers: [
        "📈 Notları yükseltmek ve 'yeni nesil' soruları geçmek",
        "🌟 Odaklanmayı ve özgüveni artırmak",
        "🏫 Lise ve gelecek sınavlar için hazırlık yapmak",
        "🤓 Stresi azaltmak ve matematiği daha kolay anlamak"
      ],
    },
    5: {
      question: "Çocuğunuzun matematik ve gelecekteki sınavlar için ekstra desteğe ihtiyacı var mı?",
      answers: [
        "✅ Evet, düzenli desteğe ihtiyaçları var",
        "🤔 Belki, şimdilik idare ediyor ama ekstra yardım iyi olabilir",
        "❌ Hayır, şu anki ilerlemeleriyle gayet iyi gidiyorlar"
      ],
    },
    6: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/turkey_longquiz_softskills_4.webp",
      title: "Matematik Zorluklarını Başarıya Dönüştürün",
      subtitle: "Kodland'in 'Okul İçin Matematik' programıyla çocuğunuz:<br>📚 Okulda daha iyi notlar alır ve ödevlerde daha kolay ilerler.<br>🎯 Özgüven kazanır: 'Yeni nesil' sorularda ustalaşır.<br>😌 Stres olmadan öğrenir: Etkileşimli ve eğlenceli derslerle.",
      button: "Ücretsiz denemenizi şimdi ayırtın!",
    },
    7: {
      title: "Çocuğunuzun Yaşını Seçin",
      subtitle: "Uzman öğretmenlerimiz, çocuğunuzun matematik özgüveni kazanmasını ve okul performansını artırmasını sağlar.",
      type: "age",
      button: "",
    },
    8: {
      question:
        "Çocuğunuzun çalışması için bir masaüstü veya dizüstü bilgisayarınız var mı?",
      answers: [
        "👍 Evet",
        {
          answer: "👎 Hayır",
          stopAnswer: true,
        },
      ],
    },
    9: {
      title: "ÜCRETSİZ matematik deneme dersi için bir tarih seçin!",
      typeInfo: "congrats",
      subtitle:
        "Çocuğunuzun matematik becerilerini geliştirecek stresiz bir deneyim için yerinizi ayırtın.",
      button: "📅 Ücretsiz Dersimi Planla",
    },
    10: {
      title: "Ücretsiz ders rezervasyonu yapın",
      type: "one-page-contacts",
      subtitle: "",
      button: "Neredeyse bitti 🔥",
    },
    11: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    12: {
      title:
        "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Lütfen not edin:<br>• Çalışan bir bilgisayar veya dizüstü gerekli.<br>• Ders sırasında ebeveyn bulunmalı.<br>• Dersler, özgüveni ve matematik başarısını artırmak için kişiselleştirilmiştir.Adım adım matematik zorluklarını aşalım!",
      button: "Sırada ne var?",
    },
    13: {
      title: "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    14: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    }
  },
};
